import sportTypeConfig from '../../configs/sportTypeConfig';

const LiveScoreGroup = ({ selectedSport, children }) => (
    <div
        className={`live-score__group live-score__group--sport${sportTypeConfig[selectedSport]}`}
        data-open="true"
    >
        {children}
    </div>
);

export default LiveScoreGroup;
